"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ModelConfig {
    constructor(cpi, arpdau, d1, days, organicRatio) {
        this.dailySpend = 200;
        this.cpi = 5;
        this.arpdau = .35;
        this.d1 = .5;
        this.days = 365;
        this.kfactor = 1.5;
        this.platformFee = .3;
        this.cpi = cpi;
        this.arpdau = arpdau;
        this.d1 = d1;
        this.days = days;
        this.kfactor = organicRatio;
    }
}
exports.ModelConfig = ModelConfig;



// WEBPACK FOOTER //
// ./src/modelConfig.js